import {emitter, EVENTS} from '../emitter';
import {Window} from './window';

export class Mouse {
  public static x: number = 0;
  public static y: number = 0;
  public static centerX: number = 0;
  public static centerY: number = 0;

  constructor() {
    this.mouseHandler = this.mouseHandler.bind(this);
    window.addEventListener('mousemove', this.mouseHandler);
  }

  private mouseHandler(event: MouseEvent): void {
    Mouse.x = event.clientX;
    Mouse.y = event.clientY;
    Mouse.centerX = (Mouse.x - Window.halfWidth) * 1;
    Mouse.centerY = (Mouse.y - Window.halfHeight) * 1;
    emitter.emit(EVENTS.mouse, {x: Mouse.x, y: Mouse.y, centerX: Mouse.centerX, centerY: Mouse.centerY});
  }
}
